export default {
  async getLottieLight() {
    return (await import("lottie-web/build/player/lottie_light.min.js")).default
  }
}
